// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Address from "./address.js"
import Order from "./order.js"
import OrderDeliveryShipmondo from "./order-delivery-shipmondo.js"

const modelClassData = {
  "attributes": {
    "delivery_address_id": {
      "column": {
        "default": null,
        "name": "delivery_address_id",
        "null": true,
        "type": "uuid"
      },
      "name": "delivery_address_id",
      "selected_by_default": null,
      "translated": null
    },
    "delivery_method": {
      "column": {
        "default": null,
        "name": "delivery_method",
        "null": false,
        "type": "string"
      },
      "name": "delivery_method",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "order_id": {
      "column": {
        "default": null,
        "name": "order_id",
        "null": false,
        "type": "uuid"
      },
      "name": "order_id",
      "selected_by_default": null,
      "translated": null
    },
    "price_with_vat": {
      "column": null,
      "name": "price_with_vat",
      "selected_by_default": null,
      "translated": null
    },
    "product_id": {
      "column": {
        "default": null,
        "name": "product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "product_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "OrderDelivery",
  "collectionKey": "order_deliveries",
  "collectionName": "order_deliveries",
  "i18nKey": "order_delivery",
  "camelizedLower": "orderDelivery",
  "name": "OrderDelivery",
  "nameDasherized": "order-delivery",
  "pluralName": "order_deliveries",
  "ransackable_associations": [
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "delivery_address_id",
      "name": "delivery_address",
      "macro": "belongs_to",
      "resource_name": "Address",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "belongs_to",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "OrderDeliveryShipmondo",
      "collectionName": "order_delivery_shipmondos",
      "foreignKey": "order_delivery_id",
      "name": "order_delivery_shipmondo",
      "macro": "has_one",
      "resource_name": "OrderDeliveryShipmondo",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "product_id",
      "name": "product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "delivery_address_id",
      "column": {
        "default": null,
        "name": "delivery_address_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "delivery_method",
      "column": {
        "default": null,
        "name": "delivery_method",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "order_id",
      "column": {
        "default": null,
        "name": "order_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "price_cents",
      "column": {
        "default": 0,
        "name": "price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "price_currency",
      "column": {
        "default": "DKK",
        "name": "price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "price_with_vat_cents",
      "column": {
        "default": 0,
        "name": "price_with_vat_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "price_with_vat_currency",
      "column": {
        "default": "DKK",
        "name": "price_with_vat_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "product_id",
      "column": {
        "default": null,
        "name": "product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vat_cents",
      "column": {
        "default": 0,
        "name": "vat_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "vat_currency",
      "column": {
        "default": "DKK",
        "name": "vat_currency",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "delivery_address_id",
      "name": "delivery_address",
      "macro": "belongs_to",
      "resource_name": "Address",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "order_id",
      "name": "order",
      "macro": "belongs_to",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "OrderDeliveryShipmondo",
      "collectionName": "order_delivery_shipmondos",
      "foreignKey": "order_delivery_id",
      "name": "order_delivery_shipmondo",
      "macro": "has_one",
      "resource_name": "OrderDeliveryShipmondo",
      "through": null
    }
  ],
  "paramKey": "order_delivery",
  "primaryKey": "id"
}

/** Frontend model for OrderDelivery. */
export default class OrderDelivery extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  deliveryAddressId() {
    return this.readAttributeUnderscore("delivery_address_id")
  }

  /** @returns {boolean} */
  hasDeliveryAddressId() {
    const value = this.deliveryAddressId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  deliveryMethod() {
    return this.readAttributeUnderscore("delivery_method")
  }

  /** @returns {boolean} */
  hasDeliveryMethod() {
    const value = this.deliveryMethod()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  orderId() {
    return this.readAttributeUnderscore("order_id")
  }

  /** @returns {boolean} */
  hasOrderId() {
    const value = this.orderId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  priceWithVat() {
    return this.readAttributeUnderscore("price_with_vat")
  }

  /** @returns {boolean} */
  hasPriceWithVat() {
    const value = this.priceWithVat()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  productId() {
    return this.readAttributeUnderscore("product_id")
  }

  /** @returns {boolean} */
  hasProductId() {
    const value = this.productId()

    return this._isPresent(value)
  }

  /** @returns {import("./address.js").default | null} */
  deliveryAddress() {
    return this._readBelongsToReflection({modelClass: Address, reflectionName: "delivery_address"})
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  loadDeliveryAddress() {
    if (!("deliveryAddressId" in this)) throw new Error("Foreign key method wasn't defined: deliveryAddressId")

    const id = this.deliveryAddressId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "delivery_address",
        model: this,
        modelClass: Address
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  ensureDeliveryAddressLoaded() {
    return this.ensureAssociationLoaded("delivery_address")
  }

  /** @returns {import("./order.js").default | null} */
  order() {
    return this._readBelongsToReflection({modelClass: Order, reflectionName: "order"})
  }

  /** @returns {Promise<import("./order.js").default | null>} */
  loadOrder() {
    if (!("orderId" in this)) throw new Error("Foreign key method wasn't defined: orderId")

    const id = this.orderId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "order",
        model: this,
        modelClass: Order
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./order.js").default | null>} */
  ensureOrderLoaded() {
    return this.ensureAssociationLoaded("order")
  }

  /** @returns {import("./order-delivery-shipmondo.js").default | null} */
  orderDeliveryShipmondo() {
    return this._readHasOneReflection({modelClass: OrderDeliveryShipmondo, reflectionName: "order_delivery_shipmondo"})
  }

  /** @returns {Promise<import("./order-delivery-shipmondo.js").default | null>} */
  loadOrderDeliveryShipmondo() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["order_delivery_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "order_delivery_shipmondo",
        model: this,
        modelClass: OrderDeliveryShipmondo
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./order-delivery-shipmondo.js").default | null>} */
  ensureOrderDeliveryShipmondoLoaded() {
    return this.ensureAssociationLoaded("order_delivery_shipmondo")
  }
}
